import classnames from 'classnames'
import RadioList from './RadioList'

import './horizontalRadioList.scss'


const HorizontalRadioList = props => <RadioList {...props} className={classnames('horizontal-radio-list', props.className)} />

export default HorizontalRadioList
